import { jobBoardAPI } from './base';
import { Employee } from 'data/users';

const unwrap = <T>(responseData: any): T => {
  // Backend often wraps with { data: ... }
  return (responseData?.data ?? responseData) as T;
};

export interface OnCallAssignment {
  _id: string;
  assignees: Employee[];
  startDate: string;
  endDate: string;
  notes?: string;
  autoGenerated?: boolean;
  assigneeColors?: Record<string, string>;
}

export interface OnCallStat {
  user: Employee;
  days: number;
  currentStreak: number;
  longestStreak: number;
}

export const getAssignments = async (params?: {
  start?: string;
  end?: string;
}): Promise<OnCallAssignment[]> => {
  // NOTE: API_BASE_URL already includes `/v1/`. Do not prefix with `/` or axios
  // will drop the `/v1` path segment.
  const response = await jobBoardAPI.get('call-out-calendar', { params });
  return unwrap<OnCallAssignment[]>(response.data);
};

export const createAssignment = async (
  payload: any
): Promise<OnCallAssignment> => {
  const response = await jobBoardAPI.post('call-out-calendar', payload);
  return unwrap<OnCallAssignment>(response.data);
};

export const updateAssignment = async ({
  id,
  payload
}: {
  id: string;
  payload: any;
}): Promise<OnCallAssignment> => {
  const response = await jobBoardAPI.post(`call-out-calendar/${id}`, payload);
  return unwrap<OnCallAssignment>(response.data);
};

export const deleteAssignment = async (id: string): Promise<void> => {
  await jobBoardAPI.delete(`call-out-calendar/${id}`);
};

export const getStats = async (year: number): Promise<OnCallStat[]> => {
  const response = await jobBoardAPI.get(
    `call-out-calendar/stats/year/${year}`
  );
  return unwrap<OnCallStat[]>(response.data);
};

export const generateRotation = async (
  payload: any
): Promise<OnCallAssignment[]> => {
  const response = await jobBoardAPI.post(
    'call-out-calendar/rotation',
    payload
  );
  return unwrap<OnCallAssignment[]>(response.data);
};

export const substituteAssignment = async ({
  id,
  payload
}: {
  id: string;
  payload: any;
}): Promise<OnCallAssignment[]> => {
  const response = await jobBoardAPI.post(
    `call-out-calendar/${id}/substitute`,
    payload
  );
  return unwrap<OnCallAssignment[]>(response.data);
};
